import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InnerImageZoom from 'react-inner-image-zoom';
import queryString from 'query-string';
import useScreen from 'hooks/useScreen';
import useGetCSSVariables from 'hooks/useGetCSSVariables';
import ImageSliderStandard from 'components/consumer/image-slider-standard';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import { EmblaSlide } from 'components/consumer/image-slider-standard/components/EmblaCarousel';
const getSlideWidth = ({
  isUltraWide,
  isExtraWide
}) => {
  let result = 500;
  if (isUltraWide) {
    result = 620;
  } else if (isExtraWide) {
    result = 875;
  }
  return result;
};
const FabricGallery = t0 => {
  const $ = _c(31);
  const {
    slides: t1,
    isMobileMaterialSwatches: t2,
    bottomRightSide,
    topRightSide
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const slides = t3;
  const isMobileMaterialSwatches = t2 === undefined ? false : t2;
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);
  const {
    isDesktop,
    isUltraWide,
    isExtraWide
  } = useScreen();
  const [isZoomIn, setIsZoomIn] = useState(false);
  let t4;
  if ($[2] !== isExtraWide || $[3] !== isUltraWide) {
    t4 = getSlideWidth({
      isUltraWide,
      isExtraWide
    });
    $[2] = isExtraWide;
    $[3] = isUltraWide;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const slideWidthInitial = t4;
  const [slideWidth, setSlideWidth] = useState(slideWidthInitial);
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["--push-across-sidebar-open-width"];
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    "--push-across-sidebar-open-width": t6
  } = useGetCSSVariables(t5);
  const pushAcrossSidebarOpenWidth = t6 === undefined ? "1px" : t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setSelectedSlideIndex(0);
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== slides) {
    t8 = [slides];
    $[7] = slides;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  useEffect(t7, t8);
  let t10;
  let t9;
  if ($[9] !== pushAcrossSidebarOpenWidth || $[10] !== slideWidth) {
    t9 = () => {
      if (pushAcrossSidebarOpenWidth === "1px") {
        return;
      }
      const slideWidthNew = parseInt(pushAcrossSidebarOpenWidth.replace("px", ""), 10);
      if (slideWidth !== slideWidthNew && slideWidthNew) {
        setSlideWidth(slideWidthNew);
      }
    };
    t10 = [pushAcrossSidebarOpenWidth, slideWidth];
    $[9] = pushAcrossSidebarOpenWidth;
    $[10] = slideWidth;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  useEffect(t9, t10);
  let t11;
  if ($[13] !== selectedSlideIndex || $[14] !== slides) {
    t11 = () => {
      const isSingleSlide = slides.length === 1;
      const slideWrapperClass = isSingleSlide ? "basis-full" : "basis-[80%] pl-0 !px-0.5";
      const slidesToShow = !isSingleSlide && slides.length < 3 ? [...slides, ...slides, ...slides] : slides;
      const isDuplicated = slidesToShow.length > slides.length;
      return slidesToShow.map((slide, slideIndex) => {
        const isSlideSelected = slideIndex === selectedSlideIndex;
        const imageSrc = `${slide.url}?${queryString.stringify(slide.imgProps)}`;
        const slideKey = isDuplicated ? `${imageSrc}-${slideIndex}` : imageSrc;
        const slideContent = <InnerImageZoom className={classNames("!h-[300px]", slide.classname)} width="100%" height={300} src={imageSrc} zoomSrc={`${slide.url}?${queryString.stringify({
          ...slide.imgProps,
          ...slide.zoomImgProps
        })}`} zoomType={isSlideSelected ? "hover" : "click"} zoomPreload={true} hasSpacer={true} hideCloseButton={true} hideHint={true} afterZoomIn={() => setIsZoomIn(true)} afterZoomOut={() => setIsZoomIn(false)} />;
        return <EmblaSlide key={slideKey} className={slideWrapperClass}>{slideContent}</EmblaSlide>;
      });
    };
    $[13] = selectedSlideIndex;
    $[14] = slides;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  const getEmblaSlideComponents = t11;
  let t12;
  if ($[16] !== getEmblaSlideComponents) {
    t12 = getEmblaSlideComponents();
    $[16] = getEmblaSlideComponents;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const slideComponents = t12;
  let t13;
  if ($[18] !== selectedSlideIndex || $[19] !== slides.length) {
    t13 = () => {
      if (slides.length === 2 && selectedSlideIndex > 1) {
        return selectedSlideIndex % slides.length + 1;
      }
      return selectedSlideIndex + 1;
    };
    $[18] = selectedSlideIndex;
    $[19] = slides.length;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const getCurrentSlideIndex = t13;
  const currentSlideIndex = getCurrentSlideIndex();
  let t14;
  if ($[21] !== bottomRightSide || $[22] !== currentSlideIndex || $[23] !== isDesktop || $[24] !== isMobileMaterialSwatches || $[25] !== isZoomIn || $[26] !== selectedSlideIndex || $[27] !== slideComponents || $[28] !== slides.length || $[29] !== topRightSide) {
    t14 = isDesktop ? <div className="FabricGallery-desktop-slider relative min-h-[300px]"><ImageSliderStandard config={{
        children: slideComponents,
        sliderConfig: {
          visibleSlides: 1.2,
          deviceOverride: true,
          afterSlideFn: setSelectedSlideIndex,
          sliderIndex: selectedSlideIndex,
          fullHeight: true
        },
        variation: {
          value: "Component"
        }
      }} fabricGridControls={true} fullWidth={true} disableSliding={isZoomIn} variant="material-swatches-sidebar" isMobileMaterialSwatches={true} />{topRightSide && topRightSide}{!!slides.length && <><div className="absolute bottom-4 left-[calc(10%_+_1rem)] w-fit"><div className="text-sm font-bold bg-white rounded-sm text-gray min-w-[43px] pt-px pr-1 pb-px pl-1.5 pointer-events-none text-center right-0 bottom-0">{`${currentSlideIndex} / ${slides.length}`}</div></div><div className="absolute bottom-4 right-[calc(10%_+_1rem)] w-fit">{bottomRightSide}</div></>}</div> : isMobileMaterialSwatches ? <div className={"relative min-h-[300px] [&_.iiz\\_\\_img--abs]:object-cover [&_.iiz\\_\\_img--abs]:object-right-bottom"}><ImageSliderStandard config={{
        children: slideComponents,
        sliderConfig: {
          visibleSlides: 1.2,
          deviceOverride: true,
          afterSlideFn: setSelectedSlideIndex,
          navType: ""
        },
        variation: {
          value: "Component"
        }
      }} disableSliding={isZoomIn} fabricGridControls={true} fullWidth={true} isMobileMaterialSwatches={isMobileMaterialSwatches} variant="material-swatches-sidebar" />{topRightSide && topRightSide}{!!slides.length && <><div className="absolute bottom-4 left-[calc(10%_+_1rem)] w-fit"><div className="text-sm font-bold rounded-sm text-gray bg-white min-w-[43px] pt-px pr-1 pb-px pl-1.5 pointer-events-none text-center right-0 bottom-0">{`${currentSlideIndex} / ${slides.length}`}</div></div><div className="absolute bottom-4 right-[calc(10%_+_1rem)] w-fit">{bottomRightSide}</div></>}</div> : <div />;
    $[21] = bottomRightSide;
    $[22] = currentSlideIndex;
    $[23] = isDesktop;
    $[24] = isMobileMaterialSwatches;
    $[25] = isZoomIn;
    $[26] = selectedSlideIndex;
    $[27] = slideComponents;
    $[28] = slides.length;
    $[29] = topRightSide;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
};
FabricGallery.propTypes = {
  bottomRightSide: PropTypes.node,
  isMobileMaterialSwatches: PropTypes.bool,
  slides: PropTypes.arrayOf(PropTypes.string),
  topRightSide: PropTypes.node
};
export default FabricGallery;